import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';

// Create Context
export const UserContext = createContext();

// Custom hook for consuming context
export const useUserContext = () => useContext(UserContext);

// Context Provider Component
export const UserProvider = ({ children }) => {
  const [userInfo, setUserInfo] = useState(() => {
    const storedUserInfo = sessionStorage.getItem('userInfo');
    return storedUserInfo
      ? JSON.parse(storedUserInfo)
      : {
          email: null,
          firstName: null,
          lastName: null,
          role: { id: null, name: null },
          permissions: [],
        };
  });

  useEffect(() => {
    sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
  }, [userInfo]);

  const value = useMemo(
    () => ({
      userInfo,
      setUserInfo,
    }),
    [userInfo],
  );

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

UserProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

// import React, { createContext, useState, useEffect, useMemo } from 'react';
// import PropTypes from 'prop-types';

// export const UserContext = createContext(null);

// export const UserProvider = ({ children }) => {
//   const [userRole, setUserRole] = useState(sessionStorage.getItem('userRole') || null);

//   useEffect(() => {
//     // Update session storage when userRole changes
//     sessionStorage.setItem('userRole', userRole);
//   }, [userRole]);

//   // Memoize the context value to prevent unnecessary re-renders
//   const value = useMemo(() => ({ userRole, setUserRole }), [userRole]);

//   return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
// };

// // Adding PropTypes validation for children
// UserProvider.propTypes = {
//   children: PropTypes.node.isRequired, // node covers anything that can be rendered
// };

// import React, { createContext, useState, useEffect, useMemo } from 'react';
// import PropTypes from 'prop-types';

// export const UserContext = createContext(null);

// export const UserProvider = ({ children }) => {
//   // Retrieve initial state from session storage or set defaults
//   const [userRole, setUserRole] = useState(sessionStorage.getItem('userRole') || null);
//   // Assuming permissions are stored as a JSON string
//   const [userPermissions, setUserPermissions] = useState(
//     JSON.parse(sessionStorage.getItem('userPermissions')) || [],
//   );

//   useEffect(() => {
//     // Update session storage when userRole changes
//     sessionStorage.setItem('userRole', userRole);
//     // Update session storage for permissions, converting array to JSON string
//     sessionStorage.setItem('userPermissions', JSON.stringify(userPermissions));
//   }, [userRole, userPermissions]);

//   // Memoize the context value to prevent unnecessary re-renders
//   // Now includes setUserPermissions and userPermissions in the context value
//   const value = useMemo(
//     () => ({
//       userRole,
//       setUserRole,
//       userPermissions,
//       setUserPermissions,
//     }),
//     [userRole, userPermissions],
//   );

//   return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
// };

// // Adding PropTypes validation for children
// UserProvider.propTypes = {
//   children: PropTypes.node.isRequired, // node covers anything that can be rendered
// };
